/**
 * 文件类型安全校验
 * 目的：拦截浏览器可直接打开或执行的文件类型，避免上传后通过文件访问地址触发
 *       存储型 XSS（html/svg/xml）或脚本执行（js/exe/jsp 等）。
 */

// 禁止上传的文件后缀（统一小写，不含点号）
export const FORBIDDEN_FILE_SUFFIXES = [
  // 网页 / 矢量图：可内嵌脚本，直接访问会执行
  'html', 'htm', 'shtml', 'xhtml', 'xht', 'svg', 'svgz',
  // 脚本文件
  'js', 'mjs', 'cjs', 'vbs', 'sh',
  // 标记语言：可构造 XSS / XXE
  'xml', 'xsl', 'xslt',
  // 可执行文件 / 安装包 / 动态库 / 批处理
  'exe', 'com', 'scr', 'msi', 'dll', 'bat', 'cmd', 'ps1',
  // 动态服务端脚本
  'jsp', 'jspx', 'asp', 'aspx', 'php'
]

/**
 * 获取文件后缀（小写，不含点号）
 * @param {File|Blob|string} file 文件对象或文件名
 * @returns {string} 后缀，无后缀时返回空字符串
 */
export function getFileSuffix(file) {
  const name = typeof file === 'string' ? file : (file && file.name) || ''
  const index = name.lastIndexOf('.')
  if (index === -1 || index === name.length - 1) {
    return ''
  }
  return name.slice(index + 1).toLowerCase()
}

/**
 * 判断是否为禁止上传的文件类型
 * @param {File|Blob|string} file 文件对象或文件名
 * @returns {boolean} 是否禁止上传
 */
export function isForbiddenFile(file) {
  const suffix = getFileSuffix(file)
  return !!suffix && FORBIDDEN_FILE_SUFFIXES.indexOf(suffix) !== -1
}

/**
 * 从 FormData 中找出第一个禁止上传的文件
 * @param {FormData} formData 表单数据
 * @returns {File|null} 命中的文件，未命中返回 null
 */
export function findForbiddenFileInFormData(formData) {
  if (!formData || typeof formData.forEach !== 'function' || typeof File === 'undefined') {
    return null
  }
  let matched = null
  formData.forEach(value => {
    if (!matched && value instanceof File && isForbiddenFile(value)) {
      matched = value
    }
  })
  return matched
}

/**
 * 生成禁止上传时的提示文案
 * @param {File|Blob|string} file 文件对象或文件名
 * @returns {string} 提示文案
 */
export function getForbiddenFileTip(file) {
  const suffix = getFileSuffix(file)
  return `不支持上传 ${suffix || '该'} 格式的文件，请更换文件后重试`
}
